import { fetcher } from '@hh.ru/front-static-app';

import { AreaId } from 'src/types/area';

const HOST = '/shards/profile/post_change_profile_area';

interface BodyValues {
    areaId: AreaId;
    isAuth: boolean;
}

type ReturnType = undefined;

declare global {
    interface FetcherPostApi {
        [HOST]: { body: BodyValues; response: ReturnType };
    }
}

const changeGeoLocationCity = async (args: BodyValues): Promise<ReturnType> => {
    const { data } = await fetcher.post<typeof HOST>(HOST, args);
    return data;
};

export default changeGeoLocationCity;
